'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

var advancedFont = plugin__default.default(({ addUtilities, theme })=>{
    const fontWeights = theme('fontWeight');
    /**
     * Nested reduce: loops through available fonts and accumulates available
     * font weight classes.
     * @example
     * ```
     * {
     *    .font-circular-black: {
     *      fontFamily: "Circular, sans-serif",
     *      fontWeight: 900,
     *    },
     *    .font-circular-regular: {
     *      fontFamily: "Circular, sans-serif",
     *      fontWeight: 400
     *    },
     *    .font-triangular-thin: {
     *      fontFamily: "Triangular, sans-serif",
     *      fontWeight: 200
     *    },
     *    ...
     * }
     * ```
     */ const fontWeightUtilityClasses = Object.entries(fontWeights).reduce((fontAcc, [fontName, weights])=>{
        const classes = Object.entries(weights ?? {}).reduce((weightAcc, [weightKey, weightValue])=>{
            return {
                ...weightAcc,
                [`.font-${fontName}-${weightKey}`]: {
                    fontFamily: theme(`fontFamily.${fontName}`),
                    fontWeight: weightValue
                }
            };
        }, {});
        return {
            ...fontAcc,
            ...classes
        };
    }, {});
    addUtilities(fontWeightUtilityClasses);
});

exports.default = advancedFont;
//# sourceMappingURL=advancedFont.js.map
